<ng-container *transloco="let t; prefix: 'nav'">
  <div class="t-pt-5 t-pb-1.5 t-pl-4 t-pr-5 t-max-h-dvh t-h-dvh">
    <div
      class="t-h-full t-rounded-lg t-bg-surface-800 t-flex t-flex-col t-transition-all t-duration-300"
      [class]="expanded() ? 't-w-[240px]' : 't-w-[64px]'"
    >
      <div
        class="t-flex"
        [class]="expanded() ? 't-justify-end' : 't-justify-center'"
      >
        <button
          class="t-m-1 t-px-2.5 t-py-1.5 t-rounded-md t-text-slate-400 hover:t-bg-surface-900"
          (click)="toggleMenu()"
        >
          <i
            class="pi"
            [class]="
              expanded() ? 'pi-angle-double-left' : 'pi-angle-double-right'
            "
          ></i>
        </button>
      </div>

      <div class="t-flex t-flex-col t-justify-between t-flex-1 t-min-h-0">
        <div
          class="t-overflow-y-auto t-flex t-flex-col t-flex-1"
          [ngClass]="{ 't-mt-4 t-gap-5': !expanded() }"
        >
          @for (menuItem of menuItems(); track menuItem.label) {
            <div
              class="t-mx-3 t-px-2.5 t-py-1.5 t-rounded-md t-text-slate-500 t-font-semibold"
              [ngClass]="{
                't-cursor-pointer hover:t-bg-surface-900': !expanded(),
              }"
              (click)="navItemClicked(menuItem)"
            >
              @if (expanded()) {
                {{ menuItem.label }}
              } @else {
                <i
                  class="t-text-slate-400"
                  [class]="menuItem.icon"
                  style="font-size: 20px"
                ></i>
              }
            </div>

            @if (expanded() && menuItem.items && menuItem.items.length > 0) {
              @for (child of menuItem.items; track child.label) {
                <!-- If it is just a link, display it with an 'a' element for 
                better browser integration -->
                @if (child.routerLink) {
                  <a
                    class="t-flex t-items-center t-gap-2 t-mx-3 t-px-2.5 t-py-1.5 t-rounded-md t-text-surface-300 t-cursor-pointer hover:t-bg-surface-900"
                    [routerLink]="child.routerLink"
                  >
                    @if (child.icon) {
                      <i [class]="child.icon"></i>
                    }
                    {{ child.label }}
                  </a>
                } @else {
                  <div
                    class="t-flex t-items-center t-gap-2 t-mx-3 t-px-2.5 t-py-1.5 t-rounded-md t-text-surface-300 t-cursor-pointer hover:t-bg-surface-900"
                    (click)="navItemClicked(child)"
                  >
                    @if (child.icon) {
                      <i [class]="child.icon"></i>
                    }
                    {{ child.label }}
                  </div>
                }
              }
            }
          }
        </div>

        <div class="t-mb-4 t-mt-2">
          <div class="t-bg-slate-400 t-h-px t-mx-2"></div>
          <div class="t-mt-4 t-flex t-flex-col t-gap-2">
            @for (bottomItem of bottomMenuItems(); track bottomItem.label) {
              <div
                class="t-flex t-items-center t-gap-2 t-mx-3 t-px-2.5 t-py-1.5 t-rounded-md t-text-surface-300 t-cursor-pointer hover:t-bg-surface-900"
                (click)="navItemClicked(bottomItem)"
              >
                @if (expanded()) {
                  <i [class]="bottomItem.icon"></i>
                  {{ bottomItem.label }}
                } @else {
                  <i
                    class="t-text-slate-400"
                    [class]="bottomItem.icon"
                    style="font-size: 20px"
                  ></i>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #menuTemplate let-data="menu"> </ng-template>
</ng-container>
